import React, { useState } from 'react';
import { Moon, X } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: 'Información que Recopilamos',
    text: 'Recopilamos únicamente la información necesaria para procesar tu compra: nombre, dirección de correo electrónico y datos de pago. No almacenamos datos de tarjetas de crédito en nuestros servidores.'
  }, {
    heading: 'Uso de la Información',
    text: 'Tu información se utiliza exclusivamente para entregar el producto digital adquirido, enviar actualizaciones relacionadas con tu compra y brindarte soporte por correo electrónico si lo solicitas.'
  }, {
    heading: 'Protección de Datos',
    text: 'Utilizamos encriptación SSL para proteger toda la información transmitida. No compartimos, vendemos ni alquilamos tus datos personales a terceros bajo ninguna circunstancia.'
  }, {
    heading: 'Cookies',
    text: 'Nuestro sitio utiliza cookies esenciales para el funcionamiento básico. No utilizamos cookies de seguimiento ni publicidad de terceros.'
  }, {
    heading: 'Tus Derechos',
    text: 'Puedes solicitar la eliminación de tus datos personales en cualquier momento escribiéndonos por correo electrónico. Procesaremos tu solicitud en un plazo máximo de 30 días.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: 'Producto Digital',
    text: 'Triada Noche Clara es un producto digital informativo. Al completar tu compra, recibirás acceso inmediato al contenido en formato PDF a través de tu correo electrónico.'
  }, {
    heading: 'Garantía de Devolución',
    text: 'Ofrecemos una garantía de devolución de 30 días sin preguntas. Si no estás satisfecho con el producto, contáctanos y procesaremos tu reembolso completo.'
  }, {
    heading: 'Uso Personal',
    text: 'El contenido adquirido es para uso personal únicamente. Queda prohibida la reproducción, distribución o reventa del material sin autorización expresa.'
  }, {
    heading: 'Descargo de Responsabilidad',
    text: 'Este producto tiene fines informativos y educativos. No sustituye el consejo médico profesional. Consulta siempre con tu médico antes de realizar cambios en tus hábitos de sueño.'
  }, {
    heading: 'Modificaciones',
    text: 'Nos reservamos el derecho de actualizar estos términos. Los cambios se publicarán en esta página con la fecha de última actualización.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const modalData = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-navy-950 py-12 border-t border-navy-900" data-id="element-36">
        <div className="container mx-auto px-6" data-id="element-37">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-38">
            <div className="flex items-center gap-2" data-id="element-39">
              <Moon className="w-6 h-6 text-gold-500" data-id="element-40" />
              <span className="text-xl font-serif text-cream-50 font-bold" data-id="element-41">
                Triada Noche Clara
              </span>
            </div>

            <div className="text-navy-400 text-sm text-center md:text-right" data-id="element-42">
              <p data-id="element-43">
                &copy; {new Date().getFullYear()} Triada Noche Clara. Todos los
                derechos reservados.
              </p>
              <div className="flex gap-6 justify-center md:justify-end mt-2" data-id="element-44">
                <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-500 transition-colors" data-id="element-45">
                  Privacidad
                </button>
                <button onClick={() => setActiveModal('terms')} className="hover:text-gold-500 transition-colors" data-id="element-46">
                  Términos
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {modalData && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-47">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-navy-950/80 backdrop-blur-sm" data-id="element-48" />

          {/* Modal Content */}
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-49">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-cream-200" data-id="element-50">
              <h2 className="text-2xl font-bold text-navy-900 font-serif" data-id="element-51">
                {modalData.title}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-navy-400 hover:text-navy-900 transition-colors p-1 rounded-lg hover:bg-cream-100" data-id="element-52">
                <X className="w-5 h-5" data-id="element-53" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto space-y-6" data-id="element-54">
              {modalData.sections.map((section, i) => <div key={i} data-id="element-55">
                  <h3 className="text-lg font-semibold text-navy-900 mb-2" data-id="element-56">
                    {section.heading}
                  </h3>
                  <p className="text-navy-600 leading-relaxed" data-id="element-57">
                    {section.text}
                  </p>
                </div>)}
              <p className="text-sm text-navy-400 pt-4 border-t border-cream-200" data-id="element-58">
                Última actualización:{' '}
                {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
              </p>
            </div>
          </div>
        </div>}
    </>;
}